import { OrganizationFormDetailPage } from "./-components/organization-form-detail-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/forms_/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <OrganizationFormDetailPage organizationId={organizationId} formId={null} tab="layout" />;
}
